import React from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import Results from './Results'
import Statistics from './Statistics/Statistics'
import StartPage from './Startpage/StartPage'
import Analyze from './Analyze/Analyze'
import Dashboards from './Dashboards/Dashboards'
import { useEffect } from 'preact/hooks'
import DashboardPage from './Dashboards/DashboardPage'
import Evaluate from './Evaluate/Evaluate'
import QueryAnalysis from './AnalyzeExternal/QueryAnalysis.js'
import AnalyzeTokenUsage from './AnalyzeTokenUsage/AnalyzeTokenUsage.js'
import AnalyzeSources from './AnalyzeSources/AnalyzeSources.js'
import AnalyzeChat from './AnalyzeSources/AnalyzeChat.js'
import AnalyzeActiveUsers from './AnalyzeActiveUsers/AnalyzeActiveUsers.js'
import ConcurrentUsers from './ConcurrentUsers/ConcurrentUsers.js'
import EvaluationTokenUsage from './AnalyzeExternal/EvaluationTokenUsage.js'
import IntegrationTests from './IntegrationTests/IntegrationTests.js'
import { TestDualLoginNormal, TestDualLoginInternal, TestDualLoginNoAuth } from './TestDualLogin/TestDualLogin.js'
import { getEnv } from './config/env'

function App() {
  useEffect(() => {
    let authUrl = ''
    let clientId = ''
    let silentRedirectPath = '/callbackSilent.html'

    let internalLoginSites = [
      '/analyze_token_usage',
      '/analyze_external_chatbot',
      '/analyze_sources',
      '/analyze_active_users',
      '/concurrent_users',
      '/evaluation_token_usage',
      '/integration_tests',
      '/test_dual_login_internal'
    ]

    let scopes = ['ai.fullaccess']
    if (window.location.pathname === '/analyze_chat') {
      scopes.push('stratsys.scorecard.readwrite')
    }

    if (internalLoginSites.includes(window.location.pathname)) {
      authUrl = getEnv('REACT_APP_INTERNAL_LOGIN_URL')
      clientId = getEnv('REACT_APP_CLIENT_ID')
    } else {
      authUrl = getEnv('REACT_APP_AUTH_URL')
      clientId = getEnv('REACT_APP_CLIENT_ID')
    }

    console.log('Running...')
    console.log('Auth URL:', authUrl)
    console.log('Client ID:', getEnv('REACT_APP_CLIENT_ID'))

    window.PDR.init({
      auth: {
        authorityUrl: authUrl,

        silentRedirectPath: silentRedirectPath,
        popupRedirectPath: '/callbackPopup.html',

        clientId: clientId,
        responseType: 'code',
        scope: scopes.join(' ')
      }
    })
  }, [])
  return (
    <Router>
      <Routes>
        <Route path="/" element={<StartPage />} />
        <Route path="/results" element={<Results />} />
        <Route path="/statistics" element={<Statistics />} />
        <Route path="/analyze" element={<Analyze />} />
        <Route path="/dashboards" element={<Dashboards />} />
        <Route path="/dashboardpage" element={<DashboardPage />} />
        <Route path="/evaluate" element={<Evaluate />} />
        <Route path="/analyze_external_chatbot" element={<QueryAnalysis />} />
        <Route path="/analyze_token_usage" element={<AnalyzeTokenUsage />} />
        <Route path="/analyze_sources" element={<AnalyzeSources />} />
        <Route path="/analyze_chat" element={<AnalyzeChat />} />
        <Route path="/analyze_active_users" element={<AnalyzeActiveUsers />} />
        <Route path="/concurrent_users" element={<ConcurrentUsers />} />
        <Route path="/evaluation_token_usage" element={<EvaluationTokenUsage />} />
        <Route path="/integration_tests" element={<IntegrationTests />} />
        <Route path="/test_dual_login" element={<TestDualLoginNormal />} />
        <Route path="/test_dual_login_normal" element={<TestDualLoginNormal />} />
        <Route path="/test_dual_login_internal" element={<TestDualLoginInternal />} />
        <Route path="/test_dual_login_noauth" element={<TestDualLoginNoAuth />} />
      </Routes>
    </Router>
  )
}

export default App
